( function () {
    'use strict';
    ( function ( $ ) {
        $('.newsletter-video').each(function(){            
            $(this).parent().on('click',function(e){
                e.preventDefault();   
                var tvideo = $(this).find('video')[0];
                if(!$(this).hasClass('playing')){
                    $(this).addClass('playing');
                    tvideo.play();
                    tvideo.addEventListener('ended',function(){
                        $(this).parent().removeClass('playing');
                    });
                }
                else{
                    $(this).removeClass('playing');
                    tvideo.pause();
                }
            });
        });
    } )( jQuery );
} )();